import { render } from "./ProjectsFilter.vue?vue&type=template&id=1c586781&scoped=true"
import script from "./ProjectsFilter.vue?vue&type=script&lang=js"
export * from "./ProjectsFilter.vue?vue&type=script&lang=js"

import "./ProjectsFilter.vue?vue&type=style&index=0&id=1c586781&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src886087124/src/dt-dashboard-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c586781"]])

export default __exports__